/*
 * @Descripttion:
 * @Author: zcy
 * @Date: 2022-01-05 16:20:00
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-06-09 17:34:08
 */
import http from "@/axios/index"
import {
  Message
} from 'element-ui';
const PagelayoutFunction = {
  // 收起多余的search参数
  PageSearchClose(that) {
    const el = that.$refs.searchBox;
    that.PageDisplay = false;
    el.children[0].style.height = "56px";
    el.children[0].style.overflow = "hidden";
  },
  // 展开多余的search参数
  PageSearchOn(that) {
    const el = that.$refs.searchBox;
    that.PageDisplay = true
    el.children[0].style.height = "auto";
    el.children[0].style.overflow = "visible";
  },
  /**
   * @brief: 下载/导出
   * @author: Scarlett Xiao
   * @Date: 2021-08-19 20:43:40
   * @param {string} url 路径
   * @param {boolean} loading 加载中动画
   * @param {any} params 
   */
  exportDatas(url, params) {
    const requestParams = params || '';
    if (requestParams !== '') {
      return new Promise(resolve => {
        http.postDownload(url, requestParams).then((data) => {
          const res = data;
          let blob;

          function fileout() {
            // 下载文件
            blob = new Blob([res], {
              type: 'application/vnd.ms-excel'
            });
            const file_Name = requestParams.fileName + '.xls';
            if (window.navigator.msSaveOrOpenBlob) { // For IE浏览器
              navigator.msSaveBlob(blob, file_Name);
            } else { // For 其他浏览器
              const objectUrl = URL.createObjectURL(blob);
              const a = document.createElement('a');
              document.body.appendChild(a);
              a.setAttribute('style', 'display:none');
              a.setAttribute('href', objectUrl);
              a.setAttribute('download', file_Name);
              a.click();
              URL.revokeObjectURL(objectUrl);
            }
          }

          //将字符串转换成 Blob对象
          blob = new Blob([res], {
            type: 'text/plain'
          });
          //将Blob 对象转换成字符串
          var reader = new FileReader();
          reader.readAsText(blob, 'utf-8');
          reader.onload = function (e) {
            try {
              // 下载文件出错
              if (JSON.parse(reader.result) && JSON.parse(reader.result)['code'] != '0000') {
                // 提示错误信息
                Message.error(JSON.parse(reader.result)['msg']);
                return;
              } else {
                // 文件导出
                fileout();
              }
            } catch (error) {
              // 文件导出
              fileout();
            }

          }

          resolve(false);
        });
      })
    }
  },
  // 固定列表表头
  pagesTableFixed() {
    const container = document.getElementsByClassName('page-list-content')[0];

    function fixedHeader(e) {
      const list_label = document.getElementsByClassName('page-search-content')[0];
      const type_label = document.getElementsByClassName('page-type-switch')[0];
      const thead = document.getElementsByClassName('el-table__header-wrapper')[0];
      // list_label是搜索参数区域的高度
      // type_label是类型切换区域的高度
      // thead是表头的高度
      if (e.target.scrollTop >= list_label.clientHeight) {
        thead.style.position = 'relative';
        // 相对定位减去list-content
        thead.style.transform = 'translateY(' + (e.target.scrollTop - 60) + 'px)';
        thead.style.boxShadow = '0 2px 12px 0 rgba(0, 0, 0, 0.1)';
        thead.style.zIndex = '999';
      } else {
        thead.style.position = 'unset';
        thead.style.transform = 'unset';
        thead.style.boxShadow = 'unset';
        thead.style.zIndex = 'unset';
      }
    }
    container && container.addEventListener('scroll', fixedHeader);
  },
  // 获取当前年月日-------yyyy-MM-dd
  getCurrentDayDate(data = new Date()) {
    let date = new Date(data)
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    day < 10 ? day = "0" + day : day
    return `${year}-${month}-${day}`
  },
  // 获取当前年月-------yyyy-MM
  getCurrentMonth(data = new Date()) {
    let date = new Date(data)
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    return `${year}-${month}`
  },
  // 获取当前年---------yyyy
  getCurrentYear() {
    return `${new Date().getFullYear()}`
  },

  // 过滤table单位标题
  // orgId机构id GongSiList公司下拉数组
  orgIdFilter(orgId = "", GongSiList) {
    if (orgId) {
      for (let i = 0; i < GongSiList.length; i++) {
        if (orgId === GongSiList[i].id)
          return GongSiList[i].name
      }
    } else {
      return '水产养殖事业部'
    }
  },

  // 过滤costMonth 时间格式yyyy-MM
  // costMonth是参数中选择到的年份和月份(yyyy-MM格式)
  costMonthFilter(costMonth = "") {
    if (!costMonth) {
      let arr = this.getCurrentMonth().split("-")
      return `${arr[0]}年${arr[1]}月`
    }
    let arr = costMonth.split("-")
    return `${arr[0]}年${arr[1]}月`
  },

  // costMonth是参数中选择到的年份和月份(yyyy-MM-DD格式 转换成 XXXX年XX月XX日)
  costDayFilter(costMonth = "") {
    if (!costMonth) {
      let arr = this.getCurrentDayDate().split("-")
      return `${arr[0]}年${arr[1]}月${arr[2]}日`
    }
    let arr = costMonth.split("-")
    return `${arr[0]}年${arr[1]}月${arr[2]}日`
  },

  // 开始月-结束月 时间格式过滤
  IntervalMonthFilter(startMonth, endMonth) {
    let StartDate = startMonth.split("-")
    let EndDate = endMonth.split("-")
    return `${StartDate[0]}年${StartDate[1]}月-${EndDate[0]}年${EndDate[1]}月`
  },

  numAdd(num1, num2) {
    var baseNum, baseNum1, baseNum2;
    try {
      baseNum1 = num1.toString().split(".")[1].length;
    } catch (e) {
      baseNum1 = 0;
    }
    try {
      baseNum2 = num2.toString().split(".")[1].length;
    } catch (e) {
      baseNum2 = 0;
    }
    baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
    return (num1 * baseNum + num2 * baseNum) / baseNum;
  },

  numDiv(num1, num2) {
    var baseNum1 = 0,
      baseNum2 = 0;
    var baseNum3, baseNum4;
    try {
      baseNum1 = num1.toString().split(".")[1].length;
    } catch (e) {
      baseNum1 = 0;
    }
    try {
      baseNum2 = num2.toString().split(".")[1].length;
    } catch (e) {
      baseNum2 = 0;
    }
    baseNum3 = Number(num1.toString().replace(".", ""));
    baseNum4 = Number(num2.toString().replace(".", ""));
    return (baseNum3 / baseNum4) * Math.pow(10, baseNum2 - baseNum1);
  },
};

export default PagelayoutFunction